import { log } from 'utils/logger';

export const formDataBlob = (selectedEmbedData, contents, executorUUID, currentStepPage) => {
    log('>>>>>>>> formDataBlob <<<<<<<<', 'selectedEmbedData:', selectedEmbedData, 'contents:', contents, 'executorUUID:', executorUUID)
    const ads = selectedEmbedData.ads;
    const adsLocation = selectedEmbedData.location;
    const data = {
        embed: {
            contentOrder: selectedEmbedData.contentOrder.toUpperCase(),
            embedName: selectedEmbedData.embedName,
            embedPosition: selectedEmbedData.location === 'in-content' ? 'IN_CONTENT' : 'RAIL',
            webAdDisplayMode: _getAdsPosition(ads, adsLocation, false),
            mobileAdDisplayMode: _getAdsPosition(ads, adsLocation, true),
            showVideoAdForDesktop: selectedEmbedData.ads.video.desktop,
            showVideoAdForMobile: selectedEmbedData.ads.video.mobile,
            partnerLogoUrl: selectedEmbedData.partnerLogo.src,
            logoClickThroughUrl: selectedEmbedData.partnerLogo.url,
            brandColorCode: selectedEmbedData.brandColor,
            showMarketResearch: selectedEmbedData.revenue.marketResearch,
            showProfilingQuestions: selectedEmbedData.revenue.profilingQuestions,
            showRewards: selectedEmbedData.revenue.rewards,
            showPartnerLogo: selectedEmbedData.showPartnerLogo,
        },
        contents: Object.keys(contents).length > 0 ?  { pages: _getPages(contents) } : {},
    };
    if(!selectedEmbedData.embedUUID) data['createdBy'] = executorUUID;
    if(!!currentStepPage) data['embedWorkflowStep'] = currentStepPage.toUpperCase();
    log('>>>>>>>> formDataBlob <<<<<<<<', 'BLOB', data);
    return data;
};

const _getPages = (contents) => {
    log('>>>>>>>> _getQuestions <<<<<<<<', 'contents', contents)
    const pages = [];
    for (let content of Object.values(contents)) {
        const contentDetail = (content.contentType === "story") ? content.story : content.questionBased;
        pages.push({
            contentUUID: contentDetail.contentUUID,
            contentType: content.contentType.toUpperCase(),
            contentLive: content.contentLive,
            queuePosition: content.queuePosition,
            contentProperties: getContentPropertiesByContentType(content.contentType, content)
        })
    }
    log('>>>>>>>> _getPages <<<<<<<<', 'PAGES', pages);
    return pages;
};

const getBackgroundProperties = content => {
    const uniqueueProps = content[content.contentType === 'story' ? 'story' : 'questionBased'];
    return {
        imageProvider: uniqueueProps.imageProvider,
        imageID: uniqueueProps.imageID,
        imageURL: (uniqueueProps.imageProvider === 'SHUTTERSTOCK' || uniqueueProps.imageProvider === 'UNSPLASH') ? null : content.imageURL,
        backgroundImageURL: uniqueueProps.backgroundImageURL,
        backgroundColor: uniqueueProps.backgroundColor
    }
};

const getContentPropertiesByContentType = (contentType, content) => {
    switch (contentType){
        case 'story':
            return { ...transpileStoryContent(content.story), ...getBackgroundProperties(content) };
        case 'quiz':
        case 'poll':
            return { ...transpileQuestionBasedContent(content, content.questionBased), ...getBackgroundProperties(content) };
                default:
            return null;
    }
};

const transpileStoryContent = (contentDetail) => ({
    title: contentDetail.title,
    storyURL: contentDetail.url
});

const transpileQuestionBasedContent = (content, contentDetail) => ({
    title: contentDetail.title,
    type: contentDetail.type.toUpperCase(),
    options: _getOptions(contentDetail.options, contentDetail.type, content.contentType)
});

const _getOptions = (options, questionType, contentType) => {
    log('>>>>>>>> _getOptions <<<<<<<<', 'options', options, 'questionType', questionType, 'contentType', contentType);
    const processedOptions = [];
    for (let optionId of Object.keys(options)) {
        processedOptions.push({
            optionUUID: options[optionId].optionUUID,
            text: _includesText(questionType) ? options[optionId].text : null,
            imageProvider: _includesImage(questionType) ? options[optionId].imageProvider : null,
            imageID: _includesImage(questionType) ? options[optionId].imageID : null,
            imageURL: _includesImage(questionType) ? (options[optionId].imageProvider === 'SHUTTERSTOCK' || options[optionId].imageProvider === 'UNSPLASH') ? null : options[optionId].imageURL : null,
            emoji: questionType === 'emoji' ? options[optionId].emoji : null,
            correctOption: contentType === 'quiz' ? options[optionId].correctOption : false
        })
    }
    log('>>>>>>>> _getOptions <<<<<<<<', 'PROCESSED OPTIONS', processedOptions);
    return processedOptions;
};

const _includesImage = questionType => ['image2', 'image1'].includes(questionType);

const _includesText = questionType => ['image1', 'text1', 'text2'].includes(questionType);

const _getAdsPosition = (ads, adsLocation, isMobile) => {
    log('>>>>>>>> _getAdsPosition <<<<<<<<', 'PROCESSED OPTIONS', 'ads', ads, 'adsLocation', adsLocation, 'isMobile', isMobile);
    const location = isMobile ? 'mobile' : 'desktop';
    const ad1 = ads[location].ad1;
    const ad2 = ads[location].ad2;
    const overlay = ads[location].overlay;
    const isRail = isMobile || adsLocation !== 'in-content';
    if (isRail && ad1 && !overlay && ad2) {
        return 'REGULAR';
    } else if (isRail && !ad1 && overlay && ad2) {
        return 'OVERLAY_TOP_AD';
    } else if (isRail && ad1 && overlay && !ad2) {
        return 'OVERLAY_BOTTOM_AD';
    } else if (!isRail && overlay) {
        return 'BOTH_OVERLAY_ADS';
    } else if (!isRail && ad1 && ad2) {
        return 'BOTH_BOTTOM_ADS';
    } else {
        return 'NONE';
    }
};


